//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ModalFormMixin } from 'core/components/forms/mixin'

export default {
    mixins: [ModalFormMixin],

    fields: [
        'email',
    ],

    dispatch: 'resendVerification',

    data() {
        return {
            submitted: false,
        }
    },

    methods: {
        onSubmitSuccess() {
            this.submitted = true
        },
    },
}
